import {Component, Input} from '@angular/core';
import {CustomError} from "../error";

@Component({
  selector: 'app-async-error',
  standalone: true,
  imports: [],
  templateUrl: './async-error.component.html',
  styleUrl: './async-error.component.scss'
})
export class AsyncErrorComponent {
  @Input() error: CustomError

}
